// モーダル表示（レストラン詳細ページ・施設/サービスページ）
$('.js-open-modal').on('click', function () {
  var target = $(this).data('menu');
  $('.l-overlay').fadeIn();
  $('.l-modal-container[data-target=' + target + ']').fadeIn();
  $('body').css('overflow', 'hidden');
  return false;
});
$('.l-overlay, .js-close-modal').on('click', function () {
  $('.l-overlay').fadeOut();
  $('.l-modal-container').fadeOut();
  $('body').css('overflow', 'auto');
});